import { Box, Typography, Tooltip } from '@mui/material';
import { FiberManualRecord } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';

export const StatusIndicator: React.FC = () => {
  const { isConnected, reconnectAttempts } = useSelector(
    (state: RootState) => state.connection
  );

  const statusColor = isConnected ? 'success.main' : 'error.main';
  const statusText = isConnected
    ? 'Connected'
    : reconnectAttempts > 0
    ? `Reconnecting... (${reconnectAttempts})`
    : 'Disconnected';

  return (
    <Tooltip title={statusText}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <FiberManualRecord sx={{ color: statusColor, fontSize: 12 }} />
        <Typography variant="body2" sx={{ display: { xs: 'none', sm: 'block' } }}>
          {statusText}
        </Typography>
      </Box>
    </Tooltip>
  );
};
